import { useEffect, type PropsWithChildren } from 'react';

import { LANDING_SCROLL_ROOT_ID } from '@pages/LandingPage/model/scroll';

export const LandingPageLayout = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const previousHtmlStyle = {
      position: html.style.position,
      inset: html.style.inset,
      width: html.style.width,
      height: html.style.height,
      overflow: html.style.overflow,
    };
    const previousBodyStyle = {
      width: body.style.width,
      height: body.style.height,
      overflow: body.style.overflow,
    };

    const previousHtmlClass = html.className;
    const previousBodyClass = body.className;

    html.style.position = 'fixed';
    html.style.inset = '0';
    html.style.width = '100%';
    html.style.height = '100%';
    html.style.overflow = 'clip';

    html.className = 'bg-background-2';
    body.className =
      'bg-background-2 mask-b-from-[calc(100%-7rem)] mask-t-from-[calc(100%-var(--landing-header-offset))] mask-y-to-100% md:mask-none';

    body.style.width = '100%';
    body.style.height = '100%';
    body.style.overflow = 'clip';

    return () => {
      html.style.position = previousHtmlStyle.position;
      html.style.inset = previousHtmlStyle.inset;
      html.style.width = previousHtmlStyle.width;
      html.style.height = previousHtmlStyle.height;
      html.style.overflow = previousHtmlStyle.overflow;

      html.className = previousHtmlClass;
      body.className = previousBodyClass;

      body.style.width = previousBodyStyle.width;
      body.style.height = previousBodyStyle.height;
      body.style.overflow = previousBodyStyle.overflow;
    };
  }, []);

  return (
    <div
      id={LANDING_SCROLL_ROOT_ID}
      data-landing-scroll-root
      className="
        landing-layout-vars fixed inset-0 overflow-x-hidden overflow-y-auto bg-background-2
        text-foreground
      "
    >
      <div className="min-h-full">{children}</div>
    </div>
  );
};

export const LandingStaticPageLayout = ({ children }: PropsWithChildren) => {
  return (
    <div className="landing-layout-vars min-h-dvh overflow-x-hidden bg-background-2 text-foreground">
      <div className="min-h-dvh">{children}</div>
    </div>
  );
};
